import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bytesToSize',
})
export class BytesToSizePipe implements PipeTransform {
  transform(bytes: number | null | undefined, decimals = 2): string {
    if (bytes == null || isNaN(bytes)) {
      return '-';
    }
    const kb = bytes / 1024;
    const mb = kb / 1024;
    const gb = mb / 1024;
    if (gb >= 1) {
      return `${gb.toFixed(decimals)} GB`;
    } else if (mb >= 1) return `${mb.toFixed(decimals)} MB`;
    return `${kb.toFixed(decimals)} KB`;
  }
}
